'use es6';

import Immutable from 'immutable';
import * as Tiers from 'marketplace-ui-common/constants/groupTags/Tiers';
import * as TierGroups from 'marketplace-ui-common/constants/groupTags/TierGroups';
export const TierGroup = Immutable.Record({
  key: '',
  tiers: Immutable.OrderedSet()
});
let _tierGroupOrder;
export const getTierGroupOrder = isUngatedForContentHub => {
  if (!_tierGroupOrder) {
    _tierGroupOrder = Immutable.OrderedSet([Tiers.HUBSPOT_FREE, TierGroup({
      key: 'marketing',
      tiers: Immutable.OrderedSet(TierGroups.MARKETING)
    }), TierGroup({
      key: 'sales',
      tiers: Immutable.OrderedSet(TierGroups.SALES)
    }), TierGroup({
      key: 'service',
      tiers: Immutable.OrderedSet(TierGroups.SERVICE)
    }), isUngatedForContentHub ? TierGroup({
      key: 'content',
      tiers: Immutable.OrderedSet(TierGroups.CONTENT)
    }) : TierGroup({
      key: 'cms',
      tiers: Immutable.OrderedSet(TierGroups.CMS)
    }), TierGroup({
      key: 'ops',
      tiers: Immutable.OrderedSet(TierGroups.OPERATIONS)
    })]);
  }
  return _tierGroupOrder;
};